<template>
  <a-card :bordered="false">
    <CustomCrumbs :data-list="crumbsList" show-name="title"></CustomCrumbs>
    <div style="height: 20px"></div>
    <search-page-view
      :col="4"
      ref="pageList"
      :itemNames="['s1','s2','s3']"
      :buttonItems="['add']"
      :columns=" getDeviceColumns()"
      :queryParams="queryParams"
      requestType="post"
      row-key="deviceId"
      :leftSpace="10"
      :requestPromise="getDeviceList"
    >
      <a-form-item slot="s1" label="设备ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.deviceId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="渠道名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.deviceChannelName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s3" label="渠道手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.deviceChannelMobile" placeholder="请输入"></a-input>
      </a-form-item>
      <a-button slot="add" type="primary" style="margin-left: 20px">
        <a-dropdown>
          <a class="ant-dropdown-link">+新建
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay" @click="addEvent">
            <a-menu-item :key="1">
              <a href="javascript:">单个添加</a>
            </a-menu-item>
            <a-menu-item :key="2">
              <a href="javascript:">批量添加</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-button>
      <span slot="status" slot-scope="rowItem">{{ getDeviceStatus(rowItem.text) }}</span>
      <span slot="action" slot-scope="rowItem">
        <a @click="toEditEvent(rowItem.record)">编辑</a>
      </span>
    </search-page-view>
    <DeviceEditorDialog
      v-if="showSingleDialog"
      :show="showSingleDialog"
      @ok="editorDeviceResult"
      :default-form="deviceForm"
      :validatorDeviceID="false"
      @cancel="showSingleDialog=false"></DeviceEditorDialog>
    <ImportFileDialog
      v-if="showImportDialog"
      :show="showImportDialog"
      @ok="importSuccess"
      @cancel="showImportDialog=false"
      :data="uploadData"
      :templateUrl="templateFileUrl"
      :url="importFileUrl"></ImportFileDialog>
  </a-card>
</template>

<script>
import smartMixins from '../smartMixins'
import CustomCrumbs from '../../../../../customComponents/CustomCrumbs'
import DeviceEditorDialog from '../components/DeviceEditorDialog.vue'
import ImportFileDialog from '../components/ImportFileDialog.vue'
import store from '@/store'

export default {
  name: 'ClDeviceList',
  mixins: [smartMixins],
  components: { CustomCrumbs, DeviceEditorDialog, ImportFileDialog },
  data() {
    return {
      crumbsList: [
        {
          title: '共享充电线(密码版)'
        },
        {
          title: '设备列表'
        }
      ],
      showSingleDialog: false,
      saveLoading: false,
      showImportDialog: false,
      templateFileUrl: 'https://imgb.woyoubooking.com/config/iotLineTemplate.xlsx',
      deviceForm: {},
      uploadData: {}
    }
  },
  created() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.platformId = this.getPlatformConfig().platformId
    const data = {
      platformId: this.platformId,
      merchantId: this.merchantId
    }
    this.uploadData = { ...data }
    this.queryParams = { ...data }
    this.importFileUrl = store.getters.appConfig.serviceUrl + '/iot/charge-line/batch/add'
  },
  mounted() {
  },
  methods: {
    getDeviceList(params) {
      return this.getHttpServices().getServerApiService().post('/iot/charge-line/list', params)
    },
    addEvent(e) {
      this.editItem = undefined//重置数据
      if (e.key === 1) {
        this.deviceForm = {}
        this.showSingleDialog = true
      } else {
        this.showImportDialog = true
      }
    },
    toEditEvent(record) {
      this.getHttpServices().getServerApiService().get('/iot/charge-line/query/' + record.id)
        .then(details => {
          this.getLogUtils().logWithTag('===query===details====', details)
          this.editItem = record
          this.deviceForm = {
            channelId: record.deviceChannelId,
            deviceKey: record.deviceCode,
            deviceNo: record.deviceId,
            remark: details.remark,
            deviceStatus: record.status
          }
          this.showSingleDialog = true
        }).catch(reason => {
        this.getLogUtils().errorWithTag('======query====', reason)
        this.showNetWorkErrorMessage(reason)
      })
    },
    //编辑结果
    editorDeviceResult(formParams) {
      this.submitLoading = true
      const id = this.editItem ? this.editItem.id : undefined
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        deviceChannelId: formParams.channelId,
        id: id,
        deviceCode: formParams.deviceKey,
        deviceId: formParams.deviceNo,
        remark: formParams.remark,
        status: formParams.deviceStatus
      }
      this.getLogUtils().logWithTag('======params=======', params)
      const path = id ? '/iot/charge-line/single/edit' : '/iot/charge-line/single/add'
      this.getHttpServices().getServerApiService().post(path, params)
        .then(res => {
          this.$message.success(id ? '编辑成功' : '新增成功')
          this.showSingleDialog = false
          this.$refs.pageList.refresh(id)
          this.getLogUtils().logWithTag('editVemDevice', res)
        }).catch(reason => {
        this.getLogUtils().errorWithTag('editVemDevice', reason)
        this.showNetWorkErrorMessage(reason)
      }).finally(() => this.submitLoading = false)
    },
    getDeviceColumns() {
      return [
        {
          title: '设备编号',
          dataIndex: 'id'
        },
        {
          title: '设备ID',
          dataIndex: 'deviceId'
        },
        {
          title: '设备密钥',
          dataIndex: 'deviceCode'
        },
        {
          title: '当前渠道',
          dataIndex: 'deviceChannelName'
        },
        {
          title: '创建时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getDeviceStatus(state) {
      //状态 0 未投放;1 在线中;2 已下线
      if (state == 0) {
        return '未投放'
      }
      if (state == 1) {
        return '在线中'
      }
      if (state == 2) {
        return '已下线'
      }
      return ''
    },
    activated() {
      this.$refs.pageList.refresh(true)
    },
    importSuccess() {
      this.showImportDialog = false
      this.$nextTick(() => this.$refs.pageList.refresh(true))
    }
  }

}
</script>
<style scoped>
</style>